import { EventType } from '@wix/editor-platform-sdk-types';

export type HostEventData<T extends object = object> = {
  eventType: EventType;
} & T;

export type EventData = {
  eventType: string;
  eventPayload?: object;
};

export const getHostEventData = <T extends object>(
  event: string,
): HostEventData<T> => {
  const emptyData: EventData = {
    eventType: '',
    eventPayload: {},
  };

  try {
    const data = JSON.parse(event) as { args?: EventData };

    const { eventType, eventPayload = {} } = data?.args ?? emptyData;

    return { eventType, ...eventPayload } as HostEventData<T>;
  } catch {
    return {
      eventType: '',
    } as HostEventData<T>;
  }
};
